import React, { useEffect, useState } from "react";
import AvoirCommande from "./AvoirCommande";
import Avoir from "./Avoir";
import { getPackingsTotalHT, isDefined } from "../../Utils";

const AvoirForm = ({ data }) => {
  const [formData, setFormData] = useState({
    tva: data?.attributes?.commande?.data?.attributes?.TVA > 0,
  });

  const isParticulier =
    data?.attributes?.commande?.data?.attributes?.particulier;

  const updateAvoir = (name, value, quantity) => {
    if (name === "packings") {
      setFormData((prev) => {
        let total = formData?.total ?? [];
        let isFound = false;
        const updatedPackings =
          formData?.packings?.map((group, index) => {
            const groupIndex = Math.max(0, group.length - 1);
            if (
              group?.some(
                (packing) =>
                  packing?.id === value[groupIndex]?.id &&
                  packing?.attributes?.soldPrice -
                    (packing?.attributes?.discount || 0) -
                    (packing?.attributes?.globalDiscount || 0) ===
                    value[groupIndex]?.attributes?.soldPrice -
                      (value[groupIndex]?.attributes?.discount || 0) -
                      (value[groupIndex]?.attributes?.globalDiscount || 0)
              )
            ) {
              isFound = true;
              if (group.length < quantity) {
                total[index] = {
                  totalHT: getPackingsTotalHT([
                    ...group,
                    value[groupIndex + 1],
                  ]),
                };
                return [...group, value[groupIndex + 1]];
              }
              return group;
            }
            return group;
          }) || [];

        if (!isFound) {
          updatedPackings.push([value[0]]);
          total[updatedPackings.length - 1] = {
            totalHT:
              -value[0]?.attributes?.soldPrice +
              (value[0]?.attributes?.discount || 0) +
              (value[0]?.attributes?.globalDiscount || 0),
          };
        }

        return {
          ...prev,
          packings: updatedPackings ?? [],
          total,
        };
      });
    } else if (name === "delivery" && !isDefined(formData?.delivery))
      setFormData((prev) => ({ ...prev, [name]: -value?.toFixed(2) }));
  };

  useEffect(() => {
    const avoirPackings = data?.attributes?.avoirPackings?.data;

    setFormData(() => {
      if (!Array.isArray(avoirPackings))
        return {
          tva: data?.attributes?.commande?.data?.attributes?.TVA > 0,
          delivery: data?.attributes?.deliveryTotal,
        };

      let total = [];

      const groupedPackings = avoirPackings?.map((group) => {
        total.push({
          totalHT: group?.attributes?.totalHT,
          quantity: group?.length,
        });
        return group?.attributes?.packings?.data;
      });

      return {
        tva: data?.attributes?.commande?.data?.attributes?.TVA > 0,
        delivery: data?.attributes?.deliveryTotal,
        total,
        packings: groupedPackings,
      };
    });
  }, [data]);

  return (
    <div className="row mt-5">
      <div className="col-6 d-flex">
        <AvoirCommande
          isParticulier={isParticulier}
          data={data?.attributes?.commande?.data}
          updateAvoir={updateAvoir}
        />
        <div className="me-4 ms-4">
          <span className="d-inline-block h-100 w-6px bg-blue"></span>
        </div>
      </div>
      <div className="col-6 d-flex">
        <Avoir
          isParticulier={isParticulier}
          id={data?.id}
          formData={formData}
          setFormData={setFormData}
          // handleChange={handleChange}
        />
      </div>
    </div>
  );
};

export default AvoirForm;
